// Lokaler Konfigurations-Stand der Betten-Konfiguratoren (Boxspring + Polsterbett).
//
// Problem: „In den Warenkorb“ ist ein nativer Form-POST auf /cart/add. Kommt der Kunde
// per Browser-Zurück aus dem Warenkorb, lädt der Konfigurator frisch und steht wieder
// auf Schritt 1 mit Standardwerten. Deshalb wird die aktuelle Auswahl laufend in der URL
// (Hash `#k=…`, base64url-JSON) und als Fallback in sessionStorage gehalten. Beim Laden
// wird sie aus dem Hash bzw. – nur bei Zurück/Vorwärts-Navigation – aus sessionStorage
// wiederhergestellt. Die Links im Warenkorb (snippets/line-item.liquid) zeigen mit
// demselben Hash-Format wieder in den Konfigurator.
//
// Nutzlast: { c: <bedConfig ohne variants/all_variant_ids/configLoaded>, s: <Schritt>, t: <Zeitstempel> }
(function () {
  'use strict';

  const STORAGE_PREFIX = 'maison-bedconfig:';
  const HASH_KEY = 'k';
  const STRIPPED_KEYS = ['variants', 'all_variant_ids', 'configLoaded'];

  function strip(config) {
    const copy = {};
    for (const key of Object.keys(config || {})) {
      if (!STRIPPED_KEYS.includes(key)) copy[key] = config[key];
    }
    return copy;
  }

  function encode(value) {
    const bytes = new TextEncoder().encode(JSON.stringify(value));
    let binary = '';
    for (let index = 0; index < bytes.length; index += 1) binary += String.fromCharCode(bytes[index]);
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function decode(text) {
    if (typeof text !== 'string' || !text) return null;
    try {
      let base64 = text.replace(/-/g, '+').replace(/_/g, '/').replace(/=+$/, '');
      while (base64.length % 4) base64 += '=';
      const binary = atob(base64);
      const bytes = new Uint8Array(binary.length);
      for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
      const json = new TextDecoder().decode(bytes);
      try {
        return JSON.parse(json);
      } catch (error) {
        // Liquid gibt Line-Item-Eigenschaften HTML-escaped aus (Link aus dem Warenkorb).
        return JSON.parse(json.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>').replace(/&amp;/g, '&'));
      }
    } catch (error) {
      return null;
    }
  }

  function normalize(payload) {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return null;
    const config = payload.c;
    if (!config || typeof config !== 'object' || Array.isArray(config)) return null;
    const step = Number(payload.s);
    return {
      config: strip(config),
      step: Number.isInteger(step) && step > 0 ? step : null,
    };
  }

  function readHash() {
    const hash = window.location.hash.replace(/^#/, '');
    if (!hash) return null;
    const params = new URLSearchParams(hash);
    return normalize(decode(params.get(HASH_KEY)));
  }

  function storageKey(productId) {
    return STORAGE_PREFIX + String(productId);
  }

  function readStorage(productId) {
    try {
      const raw = window.sessionStorage.getItem(storageKey(productId));
      return raw ? normalize(JSON.parse(raw)) : null;
    } catch (error) {
      return null;
    }
  }

  function isHistoryNavigation() {
    try {
      const entry = window.performance?.getEntriesByType?.('navigation')?.[0];
      if (entry) return entry.type === 'back_forward';
      return window.performance?.navigation?.type === 2;
    } catch (error) {
      return false;
    }
  }

  // Hash hat Vorrang (Zurück aus dem Warenkorb, Link aus dem Warenkorb). sessionStorage
  // nur bei Zurück/Vorwärts, damit ein normaler Aufruf des Konfigurators sauber startet.
  function read(productId) {
    const fromHash = readHash();
    if (fromHash) return { ...fromHash, source: 'hash' };
    if (!isHistoryNavigation()) return null;
    const fromStorage = readStorage(productId);
    return fromStorage ? { ...fromStorage, source: 'storage' } : null;
  }

  function remember({ productId, config, step } = {}) {
    if (!config || typeof config !== 'object') return;
    const payload = { c: strip(config), s: Number.isInteger(step) && step > 0 ? step : 1, t: Date.now() };
    try {
      window.sessionStorage.setItem(storageKey(productId), JSON.stringify(payload));
    } catch (error) { /* privater Modus o. ä. – URL-Hash reicht */ }
    try {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.hash.replace(/^#/, ''));
      params.set(HASH_KEY, encode(payload));
      const next = params.toString();
      if (url.hash.replace(/^#/, '') === next) return;
      url.hash = next;
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (error) { /* History-API nicht verfügbar */ }
  }

  function hasHash() {
    return readHash() !== null;
  }

  window.MaisonBedLocalState = { read, remember, encode, decode, hasHash, strip };
})();
